import React from 'react'

import { arrayOf, oneOf, shape, string, bool } from 'prop-types'

import BudgetList from './Components/BudgetList/BudgetList'

function BudgetSection({ budgets, modelType = 'cg', title = 'Budget', actionsConfig }) {
  return (
    <div className="assets-3d-categories__column assets-3d-categories__column--budget">
      <h4 className="assets-3d-categories__title">{title}</h4>
      <BudgetList items={budgets} modelType={modelType} actionsConfig={actionsConfig} />
    </div>
  )
}

BudgetSection.propTypes = {
  budgets: arrayOf(shape({
    title: string.isRequired,
    path: string.isRequired,
    icon: string.isRequired,
    withSub: bool,
  })).isRequired,
  modelType: oneOf(['cg', 'printable']),
  title: string,
  actionsConfig: shape({
    subscriptionMenuEnabled: bool,
    subscriptionFlowEnabled: bool,
    isActiveSubscriber: bool,
  }).isRequired,
}

export default BudgetSection
